/*
 * Copyright (c) 2019 Eva Novotná, Juraj Šimon
 */

import "./modernizr-custom";
import Vue from "./init";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueI18n from "vue-i18n";

Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "en", // set locale
  messages: {
    en: {
      "about me": "about me",
      "what i do": "what i do",
      "contact me": "contact me",
      "Switch language": "Switch language",
      //about me section
      Education: "Education",
      "Master's degree": "Master's degree",
      Paramedic: "Paramedic",
      "Certified specialist": "Certified specialist",
      "skiing instructor": "skiing instructor",
      "Work experience": "Work experience",
      "Race experience": "Race experience",
      //contact me
      Mobile: "Mobile",
      //footer
      "Scroll to top": "Scroll to top"
    },
    cs: {
      "about me": "o mně",
      "what i do": "co nabízím",
      "contact me": "kontakty",
      "Switch language": "Přepnout jazyk",
      //about me section
      Education: "Vzdělání",
      "Master's degree": "Magisterské studium",
      Paramedic: "Zdravotnický záchranář",
      "Certified specialist": "Diplomovaný specialista",
      "skiing instructor": "lyžařský instruktor",
      "Work experience": "Praxe",
      "Race experience": "Závody",
      //contact me
      Mobile: "Mobil",
      //footer
      "Scroll to top": "Na začátek"
    }
  }
});

let vueIntance = new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  mounted: () => {
    console.log("mounted!");
    document.dispatchEvent(new Event("x-app-rendered"));
  }
});

// eslint-disable-next-line no-undef
Modernizr.on("webp", function(result) {
  document
    .getElementsByTagName("body")[0]
    .classList.add(result ? "webp" : "no-webp");
  vueIntance.$mount("#app");
});
